<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

@if (isUploaded) {
	<div class="container">
		<div class="circle"></div>

		<span>UPLOADED</span>
	</div>
}
